import { render, staticRenderFns } from "./purchase-amount-noti.vue?vue&type=template&id=020325af&scoped=true&"
import script from "./purchase-amount-noti.vue?vue&type=script&lang=js&"
export * from "./purchase-amount-noti.vue?vue&type=script&lang=js&"
import style0 from "./purchase-amount-noti.vue?vue&type=style&index=0&id=020325af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020325af",
  null
  
)

export default component.exports